module.exports = __webpack_public_path__ + "static/media/5.ff6c477b.svg";